export type TranscriptEvent = {
  type?: string;
  item_id?: string;
  delta?: string;
  transcript?: string;
};

export type TranscriptState = {
  order: string[];
  partial: Record<string, string>;
  final: Record<string, string>;
};

export const EMPTY_TRANSCRIPT: TranscriptState = { order: [], partial: {}, final: {} };

/** Folds live transcription events into one readable line. A completed item replaces its partial. */
export function foldTranscript(state: TranscriptState, event: TranscriptEvent): TranscriptState {
  if (event.type === "session.input_transcript.delta") {
    return appendDelta(state, "input", event.delta ?? "");
  }
  const id = event.item_id;
  if (!id) return state;
  if (event.type === "conversation.item.input_audio_transcription.delta") {
    return appendDelta(state, id, event.delta ?? "");
  }
  if (event.type === "conversation.item.input_audio_transcription.completed") {
    const partial = { ...state.partial };
    delete partial[id];
    return {
      order: state.order.includes(id) ? state.order : [...state.order, id],
      partial,
      final: { ...state.final, [id]: event.transcript ?? state.partial[id] ?? "" },
    };
  }
  return state;
}

function appendDelta(state: TranscriptState, id: string, delta: string): TranscriptState {
  return {
    order: state.order.includes(id) ? state.order : [...state.order, id],
    partial: { ...state.partial, [id]: (state.partial[id] ?? "") + delta },
    final: state.final,
  };
}

export function transcriptText(state: TranscriptState): string {
  return state.order
    .map((id) => (state.final[id] ?? state.partial[id] ?? "").trim())
    .filter(Boolean)
    .join(" ")
    .trim();
}
